<script lang="ts" setup>
import type { GetBuilderResponse } from '@/api';
import { useTracking } from '@/utilities/tracking.ts';
import { getClientConfiguration } from '@/utilities/client-configuration.ts';
import { onMounted, ref } from 'vue';

const props = defineProps<{
  builder: GetBuilderResponse;
}>();

const { trackAction } = useTracking();
const staticMapUrl = ref<string>();

onMounted(() => {
  const googleMapsApiKey = getClientConfiguration().googleMapsApiKey;
  staticMapUrl.value = `https://maps.googleapis.com/maps/api/staticmap?center=${props.builder.coordinates.latitude},${props.builder.coordinates.longitude}&zoom=12&size=640x240&scale=2&markers=${props.builder.coordinates.latitude},${props.builder.coordinates.longitude}&map_id=13d35f2a07106723&key=${googleMapsApiKey}`;
});

function onClick() {
  void trackAction('builder', props.builder.id, 'mapClick');
}
</script>

<template>
  <section>
    <a :href="`https://www.google.com/maps/search/?api=1&query=${builder.coordinates.latitude},${builder.coordinates.longitude}`" rel="noopener noreferrer" target="_blank" @click="onClick">
      <div class="aspect-[8/3] overflow-hidden rounded-xl">
        <img v-if="staticMapUrl" :src="staticMapUrl" alt="Map" class="h-full w-full object-cover" />
      </div>
    </a>
  </section>
</template>

<style lang="css" scoped></style>
